import { detect, BrowserInfo } from 'detect-browser';
import { applyMiddleware, compose, createStore, StoreEnhancer } from 'redux';
import { createLogger } from 'redux-logger';
import Thunk from 'redux-thunk';

import { config } from '../common';

import RootReducer, { RootState } from './RootReducer';

export default {
    configureStore(initialState: RootState) {
        let composeEnhancers: <R>(a: R) => R;
        let middleware: StoreEnhancer;
        const browser = detect();

        // we can't use redux-logger in IE, as it throws javascript errors
        if (config.isDevAppEnv && ((browser === null || browser === undefined) || (browser as BrowserInfo).name !== 'ie')) {
            const logger = createLogger();
            middleware = applyMiddleware(Thunk, logger);
            composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        } else {
            middleware = applyMiddleware(Thunk);
            composeEnhancers = compose;
        }

        const store = createStore(
            RootReducer,
            initialState,
            composeEnhancers(middleware),
        );

        if (module.hot) {
            // Enable Webpack hot module replacement for reducers
            module.hot.accept('./RootReducer', () => {
                const nextRootReducer = require('./RootReducer').default;
                store.replaceReducer(nextRootReducer);
            });
        }

        return { store };
    },
};
